import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    const foundProducts = products && products.total > 0

    useEffect(() => {
        if(window.Flickity){
            $('.nosto-image-carousel').flickity({
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                cellAlign: 'center',
                contain: true,
            });
        }
    }, [products])

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp-markets-product',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-product-link',
            priceElement: '.ProductItem__PriceList .ns-price',
            listPriceElement: '.ProductItem__PriceList .ns-list-price',
        }).then(() => {
            document.querySelectorAll('.ns-serp .ns-serp-markets-product').forEach(el => {
                el.classList.remove('.ns-markets-product');
                el.querySelectorAll('.ProductItem__Price').forEach(priceEl => {
                    if(priceEl.textContent?.endsWith('.00')) {
                        priceEl.textContent = priceEl.textContent.slice(0, -3);
                    }
                })
            })
        });
    }, [ products?.hits ])

    return (
        <div class="ns-collection-inner">
            <div class="ns-collection-inner__products">
                <div class="ns-product-list-wrapper">

                    <div class="ns-product-list ns-product-list--grid ns-product-list-removeMargin ns-grid" data-mobile-count="2" data-desktop-count="4" style={loading ? "opacity: 0.3;" : ""}>
                        {products.hits.map((hit, index) => {
                            return <Product product={hit} key={hit.productId || index} />
                        })}
                    </div>

                </div>
            </div>
        </div>    
    )
}
